module.exports = __webpack_public_path__ + "img/powered-by-gala-logo.49102fb.svg";